import { render, staticRenderFns } from "./Proposals.html?vue&type=template&id=79d4e5e2&"
import script from "./Proposals.js?vue&type=script&lang=js&"
export * from "./Proposals.js?vue&type=script&lang=js&"
import style0 from "./Proposals.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports